<p-heading class="title" [size]="'x-large'" [tag]="'h3'">Personal Travel Budget</p-heading>

<p-divider aria-hidden="true" />

<section class="section">
  <p-heading class="section-heading" [size]="'medium'" [tag]="'h4'">
    <div class="content">
      <p-icon class="icon" [source]="'assets/icons/wallet.svg'" />
      <span>Your Budget</span>
    </div>
  </p-heading>

  <ng-container *ngrxLet="me$ as me; error as meError; suspenseTpl: spinner">
    <div *ngIf="meError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadMe()"
      >
        Reload Your Budget
      </p-button-pure>
    </div>

    <div *ngIf="!meError && me" class="budget-card">
      <div class="date">
        <p-text [align]="'center'" [size]="'x-small'">
          {{ now | date: 'MMMM' }}
          <br aria-hidden="true" />
          {{ now | date: 'dd' }}
        </p-text>
      </div>

      <div class="amount-wrapper">
        <div class="amount">
          <p-text [size]="'x-small'">Available Budget</p-text>
          <p-text [color]="'notification-info'" [size]="'large'" [weight]="'semi-bold'">
            {{ me.personalTravelBudget | opaCurrency }}
          </p-text>
        </div>

        <p-divider aria-hidden="true" />

        <div class="amount">
          <p-text [size]="'x-small'">Maximum available for Remote Travel</p-text>
          <p-text [color]="'contrast-high'" [weight]="'bold'">
            {{ me.yearlyPersonalTravelBudget | opaCurrency }}
          </p-text>
        </div>
      </div>
    </div>
  </ng-container>
</section>

<section class="section">
  <p-heading class="section-heading" [size]="'medium'" [tag]="'h4'">
    <div class="content">
      <p-icon class="icon" [source]="'assets/icons/credit-card.svg'" />
      <span>Transaction Log</span>
    </div>
  </p-heading>

  <ng-container *ngrxLet="transactionLogData$ as data; error as dataError; suspenseTpl: spinner">
    <div *ngIf="dataError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadTransactionLogData()"
      >
        Reload Transaction Log
      </p-button-pure>
    </div>

    <ng-container *ngIf="!dataError && data">
      <p-select-wrapper class="year-select" [label]="'Year'">
        <select [formControl]="yearControl">
          <option *ngFor="let year of data.activeYears" [value]="year">
            {{ year }}
          </option>
        </select>
      </p-select-wrapper>

      <p-text *ngIf="data.transactionLogs.length === 0" class="transaction-log-empty">
        No transactions.
      </p-text>

      <ng-container *ngFor="let yearLogs of data.transactionLogs; trackBy: trackYearLog">
        <div
          *ngFor="let monthLogs of yearLogs.yearTransactionLog; trackBy: trackMonthLog"
          class="transaction-log"
        >
          <p-text class="month">{{ monthLogs.monthName | titlecase }}</p-text>

          <ng-container
            *ngFor="let log of monthLogs.monthTransactionLog; trackBy: trackLog; first as first"
          >
            <div
              class="transaction"
              [ngClass]="{
                first: first,
                info: log.type === TransactionLogType.AVAILABLE,
                inflow:
                  log.type !== TransactionLogType.REMAINING &&
                  log.type !== TransactionLogType.AVAILABLE &&
                  log.amountAfter - log.amountBefore >= 0,
                outflow:
                  log.type !== TransactionLogType.REMAINING &&
                  log.type !== TransactionLogType.AVAILABLE &&
                  log.amountAfter - log.amountBefore < 0,
              }"
            >
              <div class="date">
                <p-text [size]="'xx-small'">{{ log.date | date: 'dd' }}</p-text>
              </div>

              <div class="message">
                <p-text *ngIf="!log.tripPurpose" [size]="'x-small'">
                  {{ transactionLogTypeTranslation[log.type] | transloco | titlecase }}
                </p-text>

                <ng-container *ngIf="log.tripPurpose">
                  <div class="message-line">
                    <p-text [size]="'x-small'">{{ log.tripPurpose.description }}</p-text>
                  </div>

                  <div *ngIf="log.description" class="message-line">
                    <p-icon [source]="'assets/icons/info.svg'" />
                    <p-text [size]="'xx-small'">{{ log.description }}</p-text>
                  </div>

                  <div class="message-line">
                    <p-icon [source]="'assets/icons/calendar.svg'" />
                    <p-text [size]="'xx-small'">{{ log.date | date }}</p-text>
                  </div>

                  <div class="message-line">
                    <p-link-pure [icon]="'none'" [size]="'x-small'" [underline]="true">
                      <a [routerLink]="['/personal-travel-transactions', log.id]">See Details</a>
                    </p-link-pure>
                  </div>
                </ng-container>
              </div>

              <div class="change">
                <p-text [color]="'inherit'" [weight]="'semi-bold'">
                  <ng-container
                    *ngIf="
                      log.type === TransactionLogType.REMAINING ||
                      log.type === TransactionLogType.AVAILABLE
                    "
                  >
                    {{ log.amountAfter | opaCurrency }}
                  </ng-container>

                  <ng-container
                    *ngIf="
                      log.type === TransactionLogType.ALLOWANCE ||
                      log.type === TransactionLogType.COST
                    "
                  >
                    {{ log.amountAfter - log.amountBefore | opaCurrency: null : true }}
                  </ng-container>
                </p-text>
              </div>
            </div>
            <p-divider aria-hidden="true" />
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</section>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>
